"use strict";
/**
 * @module Services.UnsubscriptionNotification
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for a UNSUBSCRIPTION_NOTIFICATION request.
 */
var UnsubscriptionNotification = /** @class */ (function () {
    /**
     * Create a new UnsubscriptionNotification instance
     *
     * @param id  the topic ID
     * @param reason  the reason for unsubscribing
     */
    function UnsubscriptionNotification(id, reason) {
        this.id = id;
        this.reason = reason;
    }
    return UnsubscriptionNotification;
}());
exports.UnsubscriptionNotification = UnsubscriptionNotification;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/unsubscription-notification/unsubscription-notification.js
// module id = 2079
// module chunks = 1